// extracted by mini-css-extract-plugin
export default {"imageContainer":"_2KVxUwrsio4FbKnXX14vKT b-profile-card__image-container"};